import { Component, Input } from '@angular/core';
import { AlertController, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { APIServiceProvider } from '../../common/services/api.service';
import { HelperServiceProvider } from '../../common/services/helper.service';
import { BankDetaisHistory } from '../bank-detail-history/bank-detail-history';

/**
 * Generated class for the ModalsBankReceiptPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-modals-bank-receipt',
  templateUrl: 'modals-bank-receipt.html',
})
export class ModalsBankReceiptPage {

  @Input() order : any = {};
  list: any = [];

   public deleteapi: any = false;

 constructor(
  public modalCtrl: ModalController,

  private apiService: APIServiceProvider,
  public viewCtrl:ViewController,
   private alertController: AlertController,
  public navParam: NavParams,
  private helper:HelperServiceProvider
) { }

  ngOnInit() { 
      this.list = this.navParam; 
      console.log(this.list.data)
}
dismiss() {
  this.viewCtrl.dismiss();
}

async  bankDetails(bank_receipt_details_id){
	this.apiService
				.post("order/finance/settlement-finance-bank-receipt-details?bank_receipt_details_id="+bank_receipt_details_id)
				.subscribe(data=>{
        
         this.openModal(data["data"]);
        },err=>{
          this.helper.presentToast(err?.error?.msg || "something wrong please try again");
        })


}
openModal(data){
  console.log(data);
  let modalObject = this.modalCtrl.create(BankDetaisHistory, {
     data:data
    });
    modalObject.present();
}

} 



// WEBPACK FOOTER //
// ./src/modals/modals-bank-receipt/modals-bank-receipt.ts